import React from "react";
import { IconChevronDown, IconCube, IconStack2 } from "@tabler/icons-react";
import clsx from "clsx";
import PopoverMenu from "components/PopoverMenu";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ROUTES_ENUM } from "routes/consts";
import useProductActions from "../useProductActions";

function CreateProductButton({
  openMenu,
  setOpenMenu,
  canCreate,
}: {
  openMenu: boolean;
  setOpenMenu: (state: boolean) => void;
  canCreate?: boolean;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { saveStateAndGetPath } = useProductActions();

  if (canCreate === false) return null;

  const openProductEditor = () => {
    const pathname = saveStateAndGetPath();
    navigate(`${pathname}/${ROUTES_ENUM.PRODUCT_EDITOR}`);
  };

  const openComponentEditor = () => navigate(`${ROUTES_ENUM.COMPONENT_EDITOR}`);

  return (
    <PopoverMenu
      panelClassName="min-w-[300px] !mt-1"
      isOpen={(state: boolean) => setOpenMenu(state)}
      customButton={
        <div
          className={clsx(
            "h-9 flex items-center justify-center bg-indigo-600 hover:bg-indigo-700 rounded-md cursor-pointer",
            "text-white whitespace-nowrap gap-2 p-2 ml-6"
          )}
        >
          {t("productSearch.createProduct")}
          <IconChevronDown
            stroke={2}
            className={clsx(
              openMenu ? " rotate-180" : "",
              "h-6 w-6 transition ease-in-out"
            )}
          />
        </div>
      }
    >
      <div
        className="flex items-center px-4 py-2 cursor-pointer hover:bg-teal-50 transition"
        onClick={openProductEditor}
      >
        <IconCube
          stroke={3}
          className={clsx(
            "bg-teal-300 rounded-full p-[3px] min-w-6 min-h-6 mr-2 text-teal-900"
          )}
        />
        <div className="pl-2">
          <span className="text-sm text-gray-700 font-medium">
            {t("mapping.createBuildingProduct")}
          </span>
          <div className="text-sm font-normal text-gray-500">
            {t("productSearch.buildingProductSubtitle")}
          </div>
        </div>
      </div>

      <div
        className="flex items-center px-4 py-2 cursor-pointer hover:bg-cyan-50 transition"
        onClick={openComponentEditor}
      >
        <IconStack2
          stroke={3}
          className={clsx(
            "bg-cyan-300 rounded-full p-[3px] min-w-6 min-h-6 mr-2 text-cyan-900"
          )}
        />
        <div className="pl-2">
          <span className="text-sm text-gray-700 font-medium">
            {t("mapping.createComponent")}
          </span>
          <div className="text-sm font-normal text-gray-500">
            {t("productSearch.componentSubtitle")}
          </div>
        </div>
      </div>
    </PopoverMenu>
  );
}

export default CreateProductButton;
